import React from "react";
import { useTranslation } from "react-i18next";
import ConfirmationModal from "../../../../parts/modals/ConfirmationModal";
import submit from "submit-form";

const TeamUnpublish = ({ cycleId, cycleName }) => {
  const { t } = useTranslation("coaching-portal");
  const handleUnpublish = (cycleId) => {
    submit(`/actions/cycle/teams-unpublish/${cycleId}`, {
      method: "GET",
    });
  };

  return (
    <ConfirmationModal
      isOpen={true}
      title={t("teams.teamUnpublish.title")}
      contentText={t("teams.teamUnpublish.confirmMessage", { cycleName })}
      cancelButtonText={t("teams.teamUnpublish.cancel")}
      cancelButtonAction={() => {
        submit(`/actions/refresh?`, {
          method: "GET",
          body: {
            "modal[type]": "",
            cycleId: "",
            cycleName: "",
          },
        });
      }}
      confirmButtonText={t("teams.teamUnpublish.unpublish")}
      confirmButtonAction={() => {
        handleUnpublish(cycleId);
      }}
      icon="delete"
      toClear={["cycleId"]}
    />
  );
};

export default TeamUnpublish;
